export const getYouTubeId = (url) => {
  try {
    const parsed = new URL(String(url || "").trim());
    if (parsed.hostname === "youtu.be") return parsed.pathname.split("/").filter(Boolean)[0] || "";
    if (parsed.hostname.endsWith("youtube.com")) {
      if (parsed.pathname === "/watch") return parsed.searchParams.get("v") || "";
      const parts = parsed.pathname.split("/").filter(Boolean);
      if (["embed", "shorts", "live"].includes(parts[0])) return parts[1] || "";
    }
  } catch (error) {
    return "";
  }
  return "";
};

export const authConfig = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });
